// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const retingRequests = {
    id: "renting_requests",
    title: "Renting requests",
    type: "group",
    children: [
      {
        id: "renting_requests",
        title: "Renting requests",
        type: "item",
        url: "/renting",
      },
    ],
  };
  
  export default retingRequests;
  